<div id="query-logic-tab-wrapper">
    <div id="query-logic-banner">
        <hyperkit-banner
          [type]="'info'"
          text="This table provides a tool-agnostic language to help analysts understand how queries should function on their system. Each row represents an indicator of suspicious activity, with optional exclusions and boolean logic defining how selections combine into a final query."
          [closable]="true"
        ></hyperkit-banner>
    </div>
    <div id="query-logic-table">
        <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th *ngFor="let column of columns">{{ column.header }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let logic of huntQueryLogic()">
                  <td *ngFor="let column of columns">{{ logic[column.field] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
    </div>
</div>
